"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareIcon = exports.EmailIcon = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * Проблемы с inline-react-svg
 * @see https://github.com/airbnb/babel-plugin-inline-react-svg/issues/95
 */

var EmailIcon = exports.EmailIcon = function EmailIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    fill = _ref.fill;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    width: width,
    height: height,
    fill: fill
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.024 17.482V6.518a2.386 2.386 0 00-2.383-2.383H2.379A2.386 2.386 0 00-.004 6.518v10.964a2.386 2.386 0 002.383 2.383h19.262a2.386 2.386 0 002.383-2.383zm-22.352.345a.773.773 0 01-.087-.345V6.518l.002-.008 5.701 5.701-5.616 5.616zM3.047 5.724h17.926l-8.718 8.718a.355.355 0 01-.49 0L3.047 5.724zm.422 12.552l4.942-4.942 2.231 2.231c.366.366.852.567 1.368.567s1.003-.201 1.368-.567l2.231-2.231 4.941 4.942H3.468zm13.263-6.065l5.701-5.701.002.009v10.964c0 .125-.035.24-.087.345l-5.616-5.616z"
  }));
};
var ShareIcon = exports.ShareIcon = function ShareIcon(_ref2) {
  var width = _ref2.width,
    height = _ref2.height,
    fill = _ref2.fill;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    width: width,
    height: height,
    fill: fill
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.758 15.829c-1.3 0-2.465.627-3.197 1.581l-6.584-3.843a4.184 4.184 0 000-3.134l6.584-3.843a4.035 4.035 0 003.197 1.581c2.249 0 4.064-1.826 4.064-4.088S21.007-.005 18.758-.005s-4.064 1.826-4.064 4.088c0 .545.108 1.09.298 1.553l-6.584 3.87c-.759-.954-1.896-1.581-3.197-1.581-2.249 0-4.064 1.826-4.064 4.088s1.815 4.088 4.064 4.088c1.3 0 2.465-.627 3.197-1.581l6.584 3.843a4.161 4.161 0 00-.298 1.553c0 2.262 1.815 4.088 4.064 4.088s4.064-1.826 4.064-4.088-1.815-4.088-4.064-4.088zm0-13.279c.86 0 1.551.695 1.551 1.56a1.551 1.551 0 11-3.102 0c0-.865.691-1.56 1.551-1.56zM5.211 13.708c-.934 0-1.685-.755-1.685-1.695a1.685 1.685 0 113.37 0c0 .94-.751 1.695-1.685 1.695zm13.547 7.644c-.791 0-1.427-.639-1.427-1.435a1.426 1.426 0 112.854 0c0 .796-.635 1.435-1.427 1.435z"
  }));
};